module.exports = __webpack_public_path__ + "img/afis.b825cf95.jpeg";